// StaffMessageDashboard.jsx
import React, { useEffect, useState } from "react";
import {fetchGlobalSettings} from "../../http/bookAPI";
import { Card } from "react-bootstrap";

const StaffMessageDashboard = () => {
    const [settings, setSettings] = useState(null);

    const load = async () => {
        try {
            const data = await fetchGlobalSettings();
            if (data?.staff_message_active && data?.staff_message_dashboard) {
                setSettings(data);
            } else {
                setSettings(null);
            }
        } catch (err) {
            console.error("Failed to load staff message:", err);
            setSettings(null);
        }
    };

    useEffect(() => {
        load();
        const poll = setInterval(load, 600000); // обновляем раз в 5 минут
        return () => clearInterval(poll);
    }, []);

    if (!settings) return null;

    return (
        <Card className="border border-secondary mb-2 mt-2">
            <Card.Body className="text-start py-1 px-3 mb-1">
    <span className="fw-semibold text-success small">
      {settings.staff_message_dashboard}
    </span>
            </Card.Body>
        </Card>
    );
};

export default StaffMessageDashboard;
